import React from "react";
import PropTypes from "prop-types";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Row,
  Col,
} from "reactstrap";
import { ToastHelper } from "../../../../helpers/alerts/alertHelper";
import { formatFecha } from "../../ErrorLogs/formatFecha";
import { ESTADO, etiquetaContexto, formatJson } from "../estados";

const preStyle = {
  whiteSpace: "pre-wrap",
  overflowX: "auto",
  maxHeight: "260px",
  fontSize: "12px",
};

const Dato = ({ label, value }) => (
  <Col md={6} className="mb-2">
    <small className="text-muted d-block">{label}</small>
    <span style={{ wordBreak: "break-all" }}>{value ?? "-"}</span>
  </Col>
);

Dato.propTypes = { label: PropTypes.string, value: PropTypes.any };

const DetailModal = ({ modal, setModal }) => {
  const item = modal.item ?? {};
  const estado = ESTADO(item.success);

  const handleClose = () => setModal({ show: false, item: null });

  const texto = () =>
    [
      `Folio: #${item.id}`,
      `Fecha: ${formatFecha(item.created_at)}`,
      `Estado: ${estado.label}`,
      `Destinatario: ${item.recipient_name ?? "-"}`,
      `Teléfono: ${item.to ?? "-"}`,
      `Tipo de envío: ${etiquetaContexto(item.context)}`,
      `Plantilla: ${item.template_id ?? "-"}`,
      `SID del mensaje: ${item.message_sid ?? "-"}`,
      `Código de error: ${item.error_code ?? "-"}`,
      `Proveedor: ${item.provider ?? "-"} / ${item.channel ?? "-"}`,
      `Ruta: ${item.route_id ?? "-"}`,
      "",
      "Payload enviado:",
      formatJson(item.payload),
      "",
      "Respuesta del proveedor:",
      formatJson(item.response),
    ].join("\n");

  const copiar = () => {
    try {
      navigator.clipboard.writeText(texto());
      ToastHelper("Detalle copiado al portapapeles", "success");
    } catch (e) {
      // navigator.clipboard no existe fuera de contextos seguros (http).
      ToastHelper("No se pudo copiar el detalle", "error");
    }
  };

  return (
    <Modal isOpen={modal.show} className="modal-dialog modal-xl">
      <ModalHeader className="bg-primary">
        Envío #{item.id} — {item.recipient_name ?? item.to}
      </ModalHeader>
      <ModalBody>
        <Row>
          <Dato label="Fecha" value={formatFecha(item.created_at)} />
          <Dato
            label="Estado"
            value={
              <span className={`badge bg-${estado.color}`}>{estado.label}</span>
            }
          />
          <Dato label="Destinatario" value={item.recipient_name} />
          <Dato label="Teléfono" value={item.to} />
          <Dato label="Tipo de envío" value={etiquetaContexto(item.context)} />
          <Dato label="Plantilla" value={item.template_id} />
          <Dato label="SID del mensaje" value={item.message_sid} />
          <Dato label="Código de error" value={item.error_code} />
          <Dato
            label="Proveedor"
            value={[item.provider, item.channel].filter(Boolean).join(" / ")}
          />
          <Dato label="Ruta" value={item.route_id} />
        </Row>

        <hr />

        <h6>Payload enviado</h6>
        <pre className="bg-light p-2" style={preStyle}>
          {formatJson(item.payload)}
        </pre>

        <h6>Respuesta del proveedor</h6>
        <pre
          className={`bg-light p-2 ${item.success === false ? "text-danger" : ""}`}
          style={preStyle}
        >
          {formatJson(item.response)}
        </pre>
      </ModalBody>
      <ModalFooter>
        <Button color="primary" onClick={copiar}>
          <i className="fa fa-copy me-1"></i> Copiar todo
        </Button>
        <Button color="secondary" onClick={handleClose}>
          Cerrar
        </Button>
      </ModalFooter>
    </Modal>
  );
};

DetailModal.propTypes = {
  modal: PropTypes.object,
  setModal: PropTypes.func,
};

export default DetailModal;
